<template>
  <v-dialog
    :value="value"
    @input="input"
    width="500"
  >
    <ChangePasswordForm
      v-model="payload"
      :errors="errors"
      @submit="save"
      @cancel="hide"
      ref="form"
    />
  </v-dialog>
</template>

<script>
import api from '@/api';
import { getUserId } from '@/helpers/authentication';

export default {
  name: 'ChangePasswordDialog',
  data() {
    return {
      payload: {
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
      },
      errors: {},
    };
  },
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
    async save() {
      try {
        await api.patch(`/users/${getUserId()}`, this.payload);
        this.$emit('input', false);
        Object.assign(this.$data, this.$options.data());
        this.$showSnackbar({ text: 'Passwort wurde geändert.', color: 'success' });
        this.$refs.form.$refs.form.reset();
      } catch (e) {
        if (e.response.status === 400) {
          this.errors = e.response.data;
        } else {
          this.$showSnackbar({ text: 'Ein unbekannter Fehler ist aufgetreten.', color: 'error' });
        }
      }
    },
    hide() {
      this.$emit('input', false);
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>
